<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>
      <!--<vs-button
              color="primary"
              type="filled"
             @click="dbYeYaz()"
          >
           Verileri Çek
          </vs-button> -->
    <vs-card>
      <div class="tw-flex tw-justify-between">
        <vs-select
            class=""
            label="Sayfadaki Etkinlik Sayısı:"
            v-model="pageSize"
            @change="handlePageSizeChange"
        >
          <vs-select-item
              v-for="size in pageSizes"
              :key="size"
              :value="size"
              :text="size"
          />
        </vs-select>

        <vs-paginator
            v-if="meta"
            :meta="meta"
            @change="handlePageChange"
        ></vs-paginator>

      </div>
    </vs-card>

    <vs-card>
      <div slot="header">
        <div class="tw-flex tw-justify-between">
          <h3>HBV Etkinlikleri</h3>

         
        </div>
      </div>

      <div class="tw-flex tw-flex-wrap">
        <div class="tw-w-full tw-flex tw-justify-between tw-items-center">
          <div class="tw-flex">
            <vs-input
                placeholder="Arama (Etkinlik Başlık)"
                v-model="search"
                v-on:keyup.enter="page = 1; get();"
            />

            <v-icon  @click="page = 1; get();" small >mdi-magnify</v-icon> 
          </div>

          
        </div>

        <div class="tw-w-full">
          <vs-divider></vs-divider>
        </div>

        <div class="tw-w-full lg:tw-w-2/2">
          <div v-if="loading">Loading...</div>

          <vs-table stripe :data="list">
            <template slot="header">
              <h3>Liste</h3>
            </template>
            <template slot="thead">
              <vs-th>#</vs-th>
               <vs-th>Etkinlik Başlık</vs-th>
              <vs-th>Etkinlik Başlangıç Tarihi</vs-th>
               <vs-th>Etkinlik Bitiş Tarihi</vs-th>
                <vs-th>Etkinlik Yeri</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="(item, i) in data" :key="i" >
                <vs-td>
                  {{ i + 1 }}.
                </vs-td>
                
                 <vs-td :data="item">
                  <div @click="show(item, i)">{{ item.eventTitle }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div @click="show(item, i)">{{ item.eventStartDate }}</div>
                </vs-td>
                <vs-td :data="item">
                  <div @click="show(item, i)">{{ item.eventEndDate }}</div>
                </vs-td>
                <vs-td :data="item">
                  <div @click="show(item, i)">{{ item.eventLocation }}</div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

        
        </div>

       
      </div>

    </vs-card>

  </div>
</template>

<script>
  import { paginatorMixin } from "@/mixins/paginatorMixin";
  import Tutorial from "@/libs/tutorials/Tutorial";
  import axios from "axios";

  export default {
    name: "yoksis-index",
    title: "YÖKSİS",

    mixins: [
      paginatorMixin,
    ],

    data() {
      return {
        obj: new Tutorial(),
        search: "",
        loading: false,
      };
    },

    computed: {
      tutorials() {
        return this.obj.tutorials
      },

      selected() {
        return this.obj.selected
      },

      saved() {
        return this.obj.saved
      },

      deleted() {
        return this.obj.deleted
      },

      list() {
        if(this.tutorials && this.tutorials.data)
          return this.tutorials.data.reverse()

        return []
      },

      meta() {
        if(this.tutorials && this.tutorials.meta)
          return this.tutorials.meta

        return null
      },

      submitted() {
        return this.obj.form.submitted
      },

      contaminated() {
        return this.obj.form.errorDetected
      }
    },

    watch: {
      contaminated(val) {
        this.loading = false
      },

      submitted(val) {
        if(val)
          this.loading = false
      },

      saved(val) {
        if(val)
          this.get()
      },

      deleted(val) {
        if(val)
          this.get()
      },
    },

    methods: {
      dbYeYaz(){
        
                     /*  this.obj.columns.pageId="asd"
                      this.obj.columns.pageName="asd"
                      this.obj.columns.eventId="asd"
                      this.obj.columns.eventTitle="asd"
                      this.obj.columns.eventUrl="asd"
                      this.obj.columns.eventContent="asd"
                      this.obj.columns.eventCreatedAt="asd"
                      this.obj.columns.eventStartDate="asd"
                      this.obj.columns.eventEndDate="asd"
                      this.obj.columns.eventLocation="asd"

                      this.loading = true
                      this.obj.create() */
           axios.get('https://hacibayram.edu.tr/api/v1/GetEvents')
          .then((response) => {
              
             
                  response.data.forEach(element => {
                  
                     
                      this.obj.columns.pageId=element.pageId
                      this.obj.columns.pageName=element.pageName
                      this.obj.columns.eventId=element.eventId
                      this.obj.columns.eventTitle=element.eventTitle
                      this.obj.columns.eventUrl=element.eventUrl
                      this.obj.columns.eventContent=element.eventContent
                      this.obj.columns.eventCreatedAt=element.eventCreatedAt
                      this.obj.columns.eventStartDate=element.eventStartDate
                      this.obj.columns.eventEndDate=element.eventEndDate
                      this.obj.columns.eventLocation=element.eventLocation

                      this.loading = true
                      this.obj.create()
                
                  });
                  
         
          
              console.log("Update finished");
              //console.log(response);
          })
          .catch(function (error) {
              // handle error
              console.log(error);
          })
          .then(function () {
              // al
          }); 
        
       
      },
      get() {
        const params = this.getRequestParams(
          this.search,
          this.page,
          this.pageSize
        );

        this.loading = true
        this.obj.getAll(params)
      },

      handlePageChange(page) {
        this.page = page;
        this.get();
      },

      handlePageSizeChange() {
        this.page = 1;
        this.get();
      },

      refreshList() {
        this.get();
        this.obj.selected = null;
      },

      show(item, index) {
        this.obj.selected = item;
      },

      removeAll() {
        this.loading = true
        this.obj.deleteAll()
      },
    },
    
    mounted() {
      this.get();
    }
  };
</script>

<style>

</style>